import { NEW_KITCHEN_CDN_PATH } from '../../new-kitchen-constants';
import { Delivery, Done, Guarantee, Project, Showrooms } from './components';

export type HeaderCardStructure = {
  name: string;
  text: string;
  icon: {
    src: string;
    alt: string;
  };
  modal: React.FC<{ onCloseModal: () => void; signUpHref: string }>;
};

export const HEADER_CARD_LIST: HeaderCardStructure[] = [
  {
    text: 'Сделаем бесплатный\nдизайн проект',
    icon: {
      src: `${NEW_KITCHEN_CDN_PATH}/header/project.png/project.png`,
      alt: 'Бесплатный дизайн проект',
    },
    name: 'free-project',
    modal: Project,
  },
  {
    text: 'Через 10\u00A0дней\nкухня у\u00A0вас дома',
    icon: {
      src: `${NEW_KITCHEN_CDN_PATH}/header/delivery.png/delivery1.png`,
      alt: 'Изготовление за 10 дней',
    },
    name: 'delivery',
    modal: Delivery,
  },
  {
    text: 'Гарантия 25 лет\nна\u00A0все изделия',
    icon: {
      src: `${NEW_KITCHEN_CDN_PATH}/header/guarantee.png/guarantee1.png`,
      alt: 'Гарантия 25 лет',
    },
    name: 'guarantee',
    modal: Guarantee,
  },
  {
    text: 'Более 1 млн\nготовых\u00A0кухонь',
    icon: {
      src: `${NEW_KITCHEN_CDN_PATH}/header/done.png/done1.png`,
      alt: 'Реализованные проекты',
    },
    name: 'projects',
    modal: Done,
  },
  {
    text: 'Шоурумы\nв\u00A0112 магазинах',
    icon: {
      src: `${NEW_KITCHEN_CDN_PATH}/header/showrooms.png/showrooms1.png`,
      alt: 'Шоурумы в магазинах',
    },
    name: 'showrooms',
    modal: Showrooms,
  },
];
